import BettingContainer from '@/components/BettingContainer';
import Footer from '@/components/common/Footer';
import Sidebar from '@/components/common/Sidebar';
import BottomNav from '@/components/BottomNav';
import Header from '@/components/Header';
import { StickySportStrip } from '@/components/common/SportStrip';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';

const GameLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  return (
    <div className="bg-shell">
      <Header onMenuClick={() => setIsSidebarOpen(true)} />

      <div className="flex xl:mt-1 xl:pr-[5px]">
        <Sidebar isOpen={isSidebarOpen} onToggle={() => setIsSidebarOpen(false)} />

        {/* `overflow-clip`, not `overflow-hidden`, so the sport strip can stick while scrolling. */}
        <div className="min-w-0 flex-1 overflow-clip">
          <StickySportStrip />
          <main className="min-w-0 overflow-hidden">
            <Outlet />
          </main>
        </div>
        <BettingContainer />
      </div>
      {/* Footer */}
      <Footer />
      <BottomNav />
    </div>
  );
};

export default GameLayout;
